function buildChildrenBackLink(wrapper) {
    const childrenBackLink = document.createElement("a");
    const li = document.createElement("li");
    childrenBackLink.classList.add("mobileMenu__backLink");
    childrenBackLink.innerText = GLOBALS.tc.back;
    li.appendChild(childrenBackLink);

    childrenBackLink.addEventListener("click", function () {
        const hasChildrenElement = childrenBackLink.closest(".hasChildren.is-open");
        if (hasChildrenElement) {
            const closestUl = hasChildrenElement.querySelector("ul");
            hasChildrenElement.classList.remove("is-open");
            if(closestUl){
                closestUl.scrollTop = 0;
                closestUl.style.overflow = "";
            }
        }
    });

    wrapper.prepend(li);
}

function buildChildrenHeader(wrapper, childrenLink) {
    const childrenHeader = document.createElement("a");
    const li = document.createElement("li");
    li.appendChild(childrenHeader);

    childrenHeader.classList.add("mobileMenu__subHeader");
    childrenHeader.innerText = childrenLink.innerText;
    if (childrenLink.tagName === 'A') {
        childrenHeader.href = childrenLink.href;
    }

    wrapper.prepend(li);
}

function addClickEventMobileMenuLink(link) {
    let hasChildren = false;
    let childrenLink = false;
    const parent = link.closest("li");
    let childrenList = false;
    const mobileMenuBody = document.querySelector('.mobileMenu__body');

    for (const children of parent.children) {
        if (children.tagName === "UL") {
            hasChildren = true;
            childrenList = children;
        }
        if (children.tagName === 'A' || children.tagName === 'SPAN') {
            childrenLink = children;
        }
    }

    if (hasChildren) {
        childrenLink.addEventListener("click", function (e) {
            const closestLi = childrenLink.closest('li');
            const closestUl = childrenLink.closest("ul");
            closestUl.scrollTop = 0;
            if (closestLi.classList.contains("is-open")) {
                closestLi.classList.remove("is-open");
                childrenLink.classList.remove("is-active");
                closestUl.style.overflow = "";
            } else {
                // Close sibling items at the same level (not ancestors) and their descendants
                const parentUl = closestLi.parentElement;
                if (parentUl) {
                    parentUl.querySelectorAll(':scope > li.is-open').forEach(sibling => {
                        if (sibling !== closestLi) {
                            sibling.classList.remove('is-open');
                            const siblingLink = sibling.querySelector(':scope > a, :scope > span');
                            if (siblingLink) siblingLink.classList.remove('is-active');
                            sibling.querySelectorAll('li.is-open').forEach(descendant => {
                                descendant.classList.remove('is-open');
                            });
                        }
                    });
                }

                closestLi.classList.add("is-open");
                childrenLink.classList.add("is-active");
            }
            mobileMenuBody.scrollTop = 0;
            e.preventDefault();
        });

        parent.classList.add("hasChildren");

        /*
        if (childrenList) {
            buildChildrenHeader(childrenList, childrenLink);
            buildChildrenBackLink(childrenList);
        }*/
    }
}

export function buildMobileMenu(menu) {
    if (menu) {
        for(const menuNavigation of menu.querySelectorAll(".mobileMenu__navigation")){
            for (const link of menuNavigation.querySelectorAll('a')) {
                addClickEventMobileMenuLink(link);
            }
            for (const activeUl of menuNavigation.querySelectorAll('.is-active,.is-active-tree')) {
                activeUl.classList.add("is-open");
            }
        }
    }
}

export function showMobileMenu(menu, overlay, toggle) {
    // Position mobile menu below .headerMain and all elements before it
    const headerMain = document.querySelector('.headerMain');
    if (headerMain) {
        // Calculate total offset including all elements before .headerMain
        const headerMainRect = headerMain.getBoundingClientRect();
        const totalOffset = headerMainRect.top + headerMainRect.height;
        menu.style.top = `${totalOffset}px`;
        menu.style.height = `calc(100vh - ${totalOffset}px)`;
    }

    menu.classList.add("is-open");
    toggle.classList.add("is-active");
    document.body.classList.add("is-mobilemenuopen");
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    document.body.classList.remove("is-mobilemenuopen");
}